import { render, staticRenderFns } from "./Invoice.yaml?vue&type=template&id=73ea2d96&component"
import script from "./Invoice.yaml?vue&type=script&lang=ts&component"
export * from "./Invoice.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports